import _ from 'lodash';
import { useModal } from '@jutro/components';
import { defineMessages } from 'react-intl';
import appConfig from 'app-config';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { useContext, useCallback, useMemo } from 'react';
import { useTranslator } from '@jutro/locale';

import { messages as commonMessages } from '@xengage/gw-platform-translations';
import screenReaderAnnounce from './ScreenReaderAnnounce';

export const useCommonUtils = (wizardDataParam = {}) => {
    const { showAlert } = useModal();
    const { wizardData } = useContext(WizardContext) || {};
    const { quoteID, jobID } = _.get(wizardData, 'value') || _.get(wizardDataParam, 'value') || {};
    const { jobType } = _.get(wizardData, 'baseData.value') || _.get(wizardDataParam ,'baseData.value') || {};
    const jobNumber = quoteID || jobID;
    const translator = useTranslator();

    const commonErrorMessages = useMemo(() => 
        defineMessages({
            entitySyncErrorMessage: {
                id: 'premier.common.SyncErrorMessage',
                defaultMessage: 'An error occurred while syncing data.\nPlease contact Underwriting with the reference number for assistance: {jobNumber}'
            },
            errorModalTitle: {
                id: 'premier.common.ErrorModalTitle',
                defaultMessage: 'Error'
            }
        })
    , []);

    const showErrorModal = useCallback(({
        message,
        title = translator(commonErrorMessages.errorModalTitle),
        shouldRedirect = true
    }) => {
        const summaryPath = appConfig.lobRedirectJobURL[jobType] ?? appConfig.lobRedirectJobURL.Submission;
        
        return showAlert({
            title,
            message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).then(() => {
            if (shouldRedirect) {
                window.location = `/producer-engage${summaryPath}/${jobNumber}/summary`;
            }
        }).catch(_.noop);
    }, [commonErrorMessages, jobNumber, jobType, showAlert, translator]);

    const formatEntityName = useCallback((entityName) => {
        const prefixesToRemove = ['', 'entity.'].join('|');
        const prefixRemover = new RegExp(prefixesToRemove);

        return entityName.replace(prefixRemover, '');

    }, []);

    return {
        showErrorModal,
        formatEntityName,
        commonErrorMessages
    };
};

export const accessibilityAddTableRow = (tableName) => {
    screenReaderAnnounce(`A new row has been added to the ${tableName} table above`);
}